/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tezos_Ecosystem_Chain_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "The following chains are in scope for the Tezos Ecosystem: Tezos and Etherlink<br /><br />endoresements, preendoresements and vdfRevelations" |
*
* @param {Tezos_Ecosystem_Chain_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const tezos_ecosystem_chain_tps_explanation = /** @type {((inputs?: Tezos_Ecosystem_Chain_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tezos_Ecosystem_Chain_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("The following chains are in scope for the Tezos Ecosystem: Tezos and Etherlink<br /><br />endoresements, preendoresements and vdfRevelations")
});